import { AnyAction } from "redux";
import { upload } from "../../../user";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const UPLOAD_IMAGE_EVENT_REQUEST = "UPLOAD_IMAGE_EVENT_REQUEST";
export const UPLOAD_IMAGE_EVENT_SUCCESS = "UPLOAD_IMAGE_EVENT_SUCCESS";
export const UPLOAD_IMAGE_EVENT_FAILURE = "UPLOAD_IMAGE_EVENT_FAILURE";
export const UPLOAD_IMAGE_EVENT = "UPLOAD_IMAGE_EVENT";

interface ActionDefault<T> {
  type: string;
  payload: T;
}

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const uploadDataRequest = () => {
  return {
    type: UPLOAD_IMAGE_EVENT_REQUEST,
  };
};

const uploadDataSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: UPLOAD_IMAGE_EVENT_SUCCESS,
    payload: data,
  };
};

const uploadDataFailure = (error: any) => {
  return {
    type: UPLOAD_IMAGE_EVENT_FAILURE,
    payload: error,
  };
};
const uploadImage = (data: any) => {
  return {
    type: UPLOAD_IMAGE_EVENT,
    payload: data,
  };
};

export const UploadImageEvent = (file: File) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(uploadDataRequest());
    try {
      const response = await upload(file);
      dispatch(uploadDataSuccess(response.data));
    } catch (error: any) {
      dispatch(uploadDataFailure(error.message));
    }
  };
};
